import type { ComponentType } from 'react';
import { ReportsPage } from './ReportsPage';

/**
 * RAPOR EKRANININ KAYDI.
 *
 * Router'a DOKUNULMAZ: `src/app/screens.ts` bu sabiti icine alir
 * (`...reportScreens`). Anahtar `src/layout/menus.ts` icindeki MENU KIMLIGI;
 * rotanin `viewReport` kapisi da oradan geliyor (router.tsx `withItemGuard`).
 */
export const reportScreens = {
  'exchange.reports': ReportsPage,
} as const satisfies Readonly<Record<string, ComponentType>>;
